<template>
  <div class="app-container">
    <!-- 数据列表 因与table-operation组件关联使用，el-table必须在第一个元素 -->
    <el-table
      :ref="tableKey"
      v-loading="loading"
      v-contextmenu:contextmenu
      :data="tableData"
      stripe
      border
      fit
      highlight-current-row
      :header-cell-class-name="sortClass"
      :empty-text="' '"
      :header-cell-style="{background:theme()}"
      style="width: 100%"
      :height="tableCustomHeight?tableCustomHeight:'600px'"
      :row-class-name="rowColor"
      :cell-style="tableCellStyle"
      @sort-change="sortChange"
      @row-contextmenu="rowContextmenu"
      @header-contextmenu="headerContextmenu"
      @row-dblclick="dblclick"
      @selection-change="handleSelectionChange"
    >
      <el-table-column
        v-if="isSelectField"
        :key="Math.random()"
        fixed
        type="selection"
        width="50"
      />
      <el-table-column
        v-for="(column, index) in tableColumns"
        :key="index"
        resizable
        :width="column.width ? column.width : 'auto'"
        :align="column.align ? column.align : 'left'"
        :min-width="column.minWidth ? column.minWidth : ''"
        :fixed="index<=lockColumnIndex"
        show-overflow-tooltip
        :label="column.label"
        :prop="column.prop"
        :sortable="sortable === 'custom' ? sortable : JSON.parse(sortable)"
        :render-header="(h,obj) => renderHeader(h,obj,column.isSpecial)"
      >
        <template slot-scope="scope">
          <span v-if="column.formatPrice">{{ scope.row[column.prop] | toThousandFilter }}</span>
          <span v-else-if="column.formatPriceNoZero">{{ scope.row[column.prop] | toThousandNoZeroFilter }}</span>
          <span v-else-if="column.isImage">
            <img
              v-for="(imgSrc, imgIndex) in scope.row[column.prop]"
              :key="imgIndex"
              :src="imgSrc"
              class="img-size"
              @click="showImage(imgIndex,scope.row[column.prop])"
            >
          </span>
          <span v-else-if="column.renderProgress">
            <el-progress
              text-inside
              :stroke-width="18"
              :percentage="scope.row[column.prop]"
              :format="handleFormatProgressText(scope.row, column.formatValueColumn)"
              :color="column.progressColors"
            />
          </span>
          <span
            v-else-if="column.isLink"
            class="link"
            @click="handleLink(scope.row)"
          >{{ scope.row[column.prop] }}</span>
          <span
            v-else-if="column.isCustomLink"
            class="link"
            @click="handleCustomLink(scope.row, column.customLinkFun)"
          >{{ scope.row[column.prop] }}</span>
          <span
            v-else-if="column.isNegativeRed"
            :class="Number(scope.row[column.prop]) < 0 ? 'normal-overdue-red' : ''"
          >{{ scope.row[column.prop] }}</span>
          <span
            v-else-if="column.isColumnFontColor"
            :style="{'color': column.columnFontColor ? column.columnFontColor : '#606266'}"
          >{{ scope.row[column.prop] }}</span>
          <span
            v-else-if="column.formatColorPrice"
            :class="Number(scope.row[column.prop]) < 0 ? 'normal-overdue-red' : (Number(scope.row[column.prop] > 0) ? 'normal-overdue-green' : '')"
          >{{ scope.row[column.prop] | toThousandFilter }}</span>
          <span
            v-else-if="column.overdueReminder"
            :class="Number(scope.row[column.prop]) > Number(column.overdueLine) ? 'normal-overdue-red' : (Number(scope.row[column.prop]) > 0) ? 'normal-overdue-green2' : ''"
          >
            {{ scope.row[column.prop] }}
          </span>
          <span v-else>{{ scope.row[column.prop] }}</span>
          <!-- {{column.formatPrice}}{{column.isImage}} -->
        </template>
      </el-table-column>
    </el-table>
    <!-- 分页组件 -->
    <pagination
      v-if="isPaging"
      :total="dataTotal"
      :page.sync="searchCondition.page"
      :limit.sync="searchCondition.limit"
      @pagination="reloadData"
    />
    <div class="total-text">
      <div
        v-if="paginationText.length > 0"
        style="width: 240px;"
      >
        {{ paginationText }}
      </div>
      <div v-if="showTotal">
        {{ totalText }}:
        <span>{{ totalAmount | toThousandFilter }}</span>
        <!-- <span v-else>{{totalAmount}}</span> -->
      </div>
    </div>
    <!-- 右键菜单 -->
    <v-contextmenu
      ref="contextmenu"
      :style="{top:positionY}"
    >
      <v-contextmenu-item
        v-if="computedTotal"
        @click="getTotal"
      >
        合计
      </v-contextmenu-item>
      <v-contextmenu-item
        v-for="(item,index) in vContextmenu"
        :key="index"
        @click="execute(item.method)"
      >
        {{ item.label }}
      </v-contextmenu-item>
      <v-contextmenu-item
        v-if="vContextmenu && vContextmenu.length>0"
        divider
      />
      <v-contextmenu-item @click="reloadData">
        刷新
      </v-contextmenu-item>
      <v-contextmenu-item
        v-if="isFilter"
        @click="filterData"
      >
        按内容筛选&lt;{{ filterContent }}&gt;
      </v-contextmenu-item>
      <v-contextmenu-item
        v-if="isFilter"
        @click="excludeData"
      >
        按内容排除&lt;{{ filterContent }}&gt;
      </v-contextmenu-item>
      <v-contextmenu-item
        v-if="isFilter"
        @click="customFilterData"
      >
        高级筛选
      </v-contextmenu-item>
      <v-contextmenu-item @click="lockColumn">
        列锁定
      </v-contextmenu-item>
    </v-contextmenu>

    <!-- 自定义筛选弹窗 -->
    <el-dialog
      title="高级筛选"
      :visible.sync="dialogCustomFilter"
      append-to-body
    >
      <el-row
        type="flex"
        :gutter="20"
        class="filter_label"
      >
        <el-col
          :span="6"
          style="padding-left:25px;"
        >
          字段名称
        </el-col>
        <el-col
          :span="5"
          style="padding-left:25px;"
        >
          条件
        </el-col>
        <el-col
          :span="5"
          style="padding-left:25px;"
        >
          <span v-if="filterCustomBetween">开始字段值</span>
          <span v-else>字段值</span>
        </el-col>
        <el-col
          v-if="filterCustomBetween"
          :span="5"
          style="padding-left:25px;"
        >
          结束字段值
        </el-col>
        <el-col
          :span="3"
          style="padding-left:25px;"
        >
          操作
        </el-col>
      </el-row>
      <el-row
        type="flex"
        :gutter="20"
      >
        <el-col :span="6">
          <el-select
            v-model="filterField"
            style="width:100%"
          >
            <el-option
              v-for="(column,index) in tableColumns"
              :key="index"
              :label="column.label"
              :value="column.prop"
            />
          </el-select>
        </el-col>
        <el-col :span="5">
          <el-select
            v-model="filterSymbol"
            @change="changeVal"
          >
            <el-option
              v-for="(symbol,index) in searchSymbol"
              :key="index"
              :label="symbol.label"
              :value="symbol.value"
              :disabled="isBetween && symbol.value==='between'"
            />
          </el-select>
        </el-col>
        <el-col
          v-if="filterInput==='select'"
          :span="5"
        >
          <el-select v-model="filterValue">
            <el-option
              v-for="(symbol,index) in filterArray"
              :key="index"
              :label="symbol.label"
              :value="symbol.value"
            />
          </el-select>
        </el-col>
        <el-col
          v-else
          :span="5"
        >
          <el-input
            v-if="filterField!=''"
            v-model="filterContent"
            :placeholder="filterField"
            clearable
            @keyup.enter.native="confirmCustomFilterFun"
          />
        </el-col>
        <el-col
          v-if="filterCustomBetween"
          :span="5"
        >
          <el-input
            v-if="filterCustomBetween"
            v-model="filterBetween"
            :placeholder="filterField"
            clearable
            @keyup.enter.native="confirmCustomFilterFun"
          />
        </el-col>
        <el-col :span="3">
          <el-button
            type="primary"
            icon="icon iconfont icon-filter "
            @click="confirmCustomFilterFun"
          >
            过滤
          </el-button>
        </el-col>
      </el-row>
      <el-row>
        <div class="instructions">
          <em>
            说明：
          </em>
          <div>
            1、选择“包含”，在字段值中输入需要查询的值。系统将查询鼠标右键选择高级过滤所在列所有包含输入的值的数据。<br>2、选择“大于，等于，小于等”，则查询大于，等于，小于等输入字段值的数据。<br>3、选择“介于”，在开始字段值和结束字段值输入值，则系统查询介于输入的值之间的数据。（例如开始值2010-08-09，结束值2010-08-12，系统则查询从9号开始至12号结束的数据。）
          </div>
        </div>
      </el-row>
    </el-dialog>

    <!-- 2、图片预览 -->
    <el-dialog
      :visible.sync="dialogVisible"
      :before-close="modalClose"
      class="preview-dialog"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      append-to-body
    >
      <!-- 技术点：一定使用v-if="dialogVisible" 不能使用v-show,否则图片展示时（假设点击的是第3张），前两张会快速的滑过-->
      <div
        v-if="dialogVisible"
        class="block"
      >
        <span
          class="el-image-viewer__btn el-image-viewer__close"
          @click="modalClose"
        ><i class="el-icon-error" /></span>
        <el-carousel
          trigger="click"
          class="imgbox"
          :autoplay="false"
          arrow="always"
          indicator-position="outside"
        >
          <el-carousel-item
            v-for="(item,index) in imagesPreview"
            :key="index"
          >
            <img
              :src="item"
              style="max-height: 100%; max-width: 100%;"
            >
          </el-carousel-item>
        </el-carousel>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import Pagination from '@/components/Pagination'
import checkPermission from '@/utils/permission'
// 暂无图片
import noImage from '@/assets/noImage.jpg'
export default {
  name: 'CustomTable',
  components: { Pagination },
  props: {
    tableKey: {
      required: true,
      type: String,
      default: 'customTable'
    },
    tableColumns: {
      required: true,
      default: null,
      type: Array
    },
    tableData: {
      required: true,
      default: null,
      type: Array
    },
    isIndexField: {
      required: false,
      default: false,
      type: Boolean
    },
    isSelectField: {
      required: false,
      default: false,
      type: Boolean
    },
    loading: {
      required: false,
      default: false,
      type: Boolean
    },
    isPaging: {
      required: false,
      default: true,
      type: Boolean
    },
    dataTotal: {
      required: false,
      default: 0,
      type: Number
    },
    searchCondition: {
      required: true,
      type: Object
    },
    tableContextmenu: {
      required: false,
      default: null,
      type: Array
    },
    tableCellBackground: {
      required: false,
      default: null,
      type: Object
    },
    dataObj: {
      required: true,
      type: Object
    },
    tableCustomHeight: {
      required: false,
      type: String,
      default: ''
    },
    sortable: {
      required: false,
      type: String,
      default: 'custom'
    },
    // 显示合计
    isShowTotal: {
      type: Boolean,
      default: false
    },
    // 需显示合计名称
    showTotalLabel: {
      type: String,
      default: ''
    },
    // 合计金额
    totalAmount: {
      type: Number,
      default: 0
    },
    // 分页显示文字
    paginationText:{
      type: String,
      default: ''
    },
    // 多选
    multipleSelection: {
      required: false,
      default: null,
      type: Array
    },
    isContextMenu: {
      type: Boolean,
      default: true
    },
    isFilter: {
      type: Boolean,
      default: true
    }
  },
  data () {
    return {
      noImage: noImage,
      lockColumnIndex: -1,
      dialogCustomFilter: false,
      searchSymbol: [
        { label: '等于', value: '=' },
        { label: '不等于', value: '<>' },
        { label: '小于', value: '<' },
        { label: '大于', value: '>' },
        { label: '包含', value: 'like' },
        { label: '介于', value: 'between' }
      ],
      filterField: '',
      filterColumn: '',
      filterSymbol: '=',
      filterValue: '',
      filterContent: '',
      filterArray: [],
      filterInput: 'text',
      filterCustomBetween: false,
      filterBetween: '',
      isBetween: false,
      rowData: '',
      // 合计
      computedTotal: false,
      totalText: '',
      showTotal: false,
      totalFormatTemp: false,
      totalFormatPrice: false,
      positionY: 0,
      dialogVisible: false, // 预览窗口是否展示，默认不展示
      downLoadFlag: true, // 下载图标展示与否，默认展示
      imagesPreview: []// 预览时根据点击的index重组的数据
    }
  },
  computed: {
    vContextmenu: function () {
      return this.tableContextmenu
        ? this.tableContextmenu.filter(v =>
          v.permissionSigns ? this.checkPermission(v.permissionSigns) : true
        )
        : null
    },
    queryCondition: {
      get () {
        return this.searchCondition
      },
      set (val) {
        this.$emit('update:searchCondition', val)
      }
    }
  },
  watch: {
    isShowTotal: {
      handler: function (newVal) {
        let _this = this;
        _this.showTotal = newVal;
        if (_this.showTotalLabel !== '') {
          _this.totalText = _this.showTotalLabel;
        }
      },
      deep: true,
      immediate: true
    }
  },
  methods: {
    checkPermission,
    theme () {
      let themeColor = this.$store.state.settings.theme
      return themeColor
    },
    reloadData () {
      this.$emit('reloadData', this.dataObj)
    },
    sortClass (args) {
      if (args.column.property && this.queryCondition.sort && args.column.property === this.queryCondition.sort.prop) {
        return this.queryCondition.sort.order
      }
    },
    sortChange (data) {
      let { prop, order } = data
      if (prop === 'rowNumber') prop = ''
      let columns = this.tableColumns.filter(item => {
        return item.prop === prop
      })
      if (columns[0].filterColumn) {
        prop = columns[0].filterColumn
      }

      if (prop && order) {
        if (order === 'ascending') {
          this.queryCondition.sort = { prop: prop, order: 'asc' }
        } else {
          this.queryCondition.sort = { prop: prop, order: 'desc' }
        }
      } else {
        this.queryCondition.sort = { prop: '', order: '' }
      }
      this.reloadData()
    },
    rowContextmenu (row, column, event) {
      if (column.property) {
        this.rowData = row
        this.filterField = column.property
        this.filterValue = row[column.property]
        this.filterContent = row[column.property]
        this.isBetween = false

        let columns = this.tableColumns.filter(item => {
          return item.prop === this.filterField
        })
        if (columns && columns.length > 0) {
          if (columns[0].allowSum) {
            this.computedTotal = true
          } else {
            this.computedTotal = false
          }
          if (columns[0].formatPrice) {
            this.totalFormatTemp = true
          } else {
            this.totalFormatTemp = false
          }
          if (columns[0].filterValue) {
            this.filterValue = row[columns[0].filterValue]
          }
          if (columns[0].filterColumn) {
            this.filterColumn = columns[0].filterColumn
          } else {
            this.filterColumn = column.property
          }
          if (columns[0].filterArray) {
            this.filterArray = columns[0].filterArray
            this.filterInput = 'select'
          } else {
            this.filterInput = 'text'
          }
          if (!columns[0].isBetween) {
            this.isBetween = true
          }
        }
        this.filterBetween = this.filterContent
        let windowH = document.body.clientHeight && document.documentElement.clientHeight
        let disYTop = event.clientY
        let disYBottom = windowH - disYTop
        let disYTop2 = disYTop - 50
        let elH = this.$refs.contextmenu.$children.length * 30 - 15
        if (disYTop2 > elH && disYBottom > elH) {
          if (disYTop2 > disYBottom) {
            this.positionY = (disYTop - elH) + 'px'
          } else {
            this.positionY = disYTop + 'px'
          }
        } else if (disYTop2 > elH) {
          this.positionY = (disYTop - elH) + 'px'
        } else if (elH > disYBottom && elH > disYTop2) {
          this.positionY = (windowH - elH) / 2 + 'px'
        } else {
          this.positionY = disYTop + 'px'
        }
      }
    },
    headerContextmenu (row, column) {
      this.filterField = ''
      this.filterContent = ''
      if (column.property) {
        this.filterField = column.property
        this.filterContent = ''
      }
    },
    dblclick (row, column) {
      this.$emit('dblclick', row, column)
    },
    filterData () {
      this.contextmenuSymbol = '='
      if (this.filterValue === 'null' || this.filterValue === null) {
        this.queryCondition.contextmenuWrap.push(`${this.filterColumn} IS ${this.filterValue}`)
      } else {
        this.queryCondition.contextmenuWrap.push(`${this.filterColumn} = '${this.filterValue}'`)
      }
      let newObj = this.dataObj
      newObj.tableQuery.page = 1
      this.$emit('reloadData', newObj)
    },
    excludeData () {
      this.contextmenuSymbol = '<>'
      if (this.filterValue === 'null' || this.filterValue === null) {
        this.queryCondition.contextmenuWrap.push(`${this.filterColumn} IS NOT ${this.filterValue}`)
      } else {
        this.queryCondition.contextmenuWrap.push(`${this.filterColumn} <> '${this.filterValue}'`)
      }
      let newObj = this.dataObj
      newObj.tableQuery.page = 1
      this.$emit('reloadData', newObj)
    },
    customFilterData () {
      this.filterSymbol = '='
      this.filterCustomBetween = false
      this.dialogCustomFilter = true
    },
    confirmCustomFilterFun () {
      if (this.filterCustomBetween) {
        this.queryCondition.contextmenuWrap.push(
          `${this.filterColumn} between '${this.filterContent}' and '${this.filterBetween}'`
        )
      } else if (this.filterInput === 'select') {
        this.queryCondition.contextmenuWrap.push(
          `${this.filterColumn} ${this.filterSymbol} '${this.filterValue}'`
        )
      } else if (this.filterSymbol === 'like') {
        this.queryCondition.contextmenuWrap.push(
          `${this.filterColumn} ${this.filterSymbol} '%${this.filterContent}%'`
        )
      } else {
        this.queryCondition.contextmenuWrap.push(
          `${this.filterColumn} ${this.filterSymbol} '${this.filterContent}'`
        )
      }
      this.dialogCustomFilter = false
      this.reloadData()
    },
    lockColumn () {
      this.tableColumns.forEach((v, i) => {
        if (v.prop === this.filterField) {
          this.lockColumnIndex = i
        }
      })
    },
    execute (method) {
      this.$emit(method, this.rowData)
    },
    // 合计回调
    getTotal () {
      let computedTotalObj = this.tableColumns.find((item) => {
        return this.filterField === item.prop
      })
      this.totalFormatPrice = this.totalFormatTemp
      this.showTotal = true
      // this.totalText = `${this.filterField}`
      this.totalText = computedTotalObj.label
      this.$emit('getTotal', this.filterField, computedTotalObj)
    },
    changeVal (val) {
      if (val === 'between') {
        this.filterCustomBetween = true
      } else {
        this.filterCustomBetween = false
      }
    },
    // 选择单个数据行
    handleSelectionChange (val) {
      this.$emit('update:multipleSelection', val)
    },
    renderHeader (h, { column }, columnSpecial) {
      if (columnSpecial) {
        return h('span', { class: 'table-head', style: { color: '#000' } }, [column.label])
      } else {
        return h('span', { class: 'table-head', style: { color: '#fff' } }, [column.label])
      }
    },
    /** 图片预览 */
    showImage (index, obj) {
      if (!this.downLoadFlag) {
        return false
      }
      this.imagesPreview = []
      this.dialogVisible = true
      let imgArr = obj
      let before = imgArr.slice(0, index)
      let after = imgArr.slice(index)
      this.imagesPreview = after.concat(before)
    },
    /** 点击链接  */
    handleLink (rowData) {
      this.$emit('linkMethod', rowData)
    },
    /** 自定义点击链接 */
    handleCustomLink (rowData, linkFunName) {
      this.$emit(linkFunName, rowData)
    },
    // 进度条显示内容格式化方法
    handleFormatProgressText (rowData, formatValueColumn) {
      return () => {
        if (formatValueColumn) {
          return rowData[formatValueColumn]
        }
      }
    },
    // Table表格渲染颜色
    // eslint-disable-next-line no-unused-vars
    rowColor (row, rowIndex) {
      let color = 'black'
      if (row && row.row['fontColor']) {
        color = row.row['fontColor']
      }
      if (color === 'boldRed') return 'normal-overdue-red-bold-td'
      else if (color === 'red') return 'normal-overdue-red-td'
      else if (color === 'yellow') return 'normal-overdue-yellow-td'
      else if (color === 'orange') return 'normal-overdue-orange-td'
      else if (color === 'blue') return 'normal-overdue-blue-td'
      else if (color === 'green') return 'normal-overdue-green-td'
      else return 'normal-overdue-set-td'
    },
    // 动态计算单元格样式
    tableCellStyle ({ row, column }) {
      let _this = this;
      if (_this.tableCellBackground && _this.tableCellBackground.columns && _this.tableCellBackground.values && _this.tableCellBackground.operations) {
        let cellIndex = _this.tableCellBackground.columns.findIndex((item) => {
          return item === column.property;
        })
        if (cellIndex >= 0) {
          let compareField = _this.tableCellBackground.fields[cellIndex];
          let compareValue = _this.tableCellBackground.values[cellIndex];
          let operation = _this.tableCellBackground.operations[cellIndex];
          let resultIsTrue = false;
          if (operation === '=') {
            resultIsTrue = row[compareField] === compareValue;
          } else if (operation === '>') {
            resultIsTrue = Number(row[compareField]) > Number(compareValue);
          } else if (operation === '>=') {
            resultIsTrue = Number(row[compareField]) >= Number(compareValue);
          } else if (operation === '<') {
            resultIsTrue = Number(row[compareField]) < Number(compareValue);
          } else if (operation === '<=') {
            resultIsTrue = Number(row[compareField]) <= Number(compareValue);
          }
          if (resultIsTrue) {
            return "background: red; color: #ffffff;";
          }
        }
      }
    },
    modalClose () {
      this.dialogVisible = false
    }
  }
}
</script>
<style lang="scss" scoped>
.app-container {
  padding: 0;
}

.pagination-container {
  padding: 0;
  margin-top: 2px;
}
.el-table--border {
  border-left: none;
}
::v-deep .el-table {
  th {
    color: #ffffff;
    .cell {
      line-height: 17px;
    }
    .caret-wrapper {
      height: 18px;
    }
    .sort-caret {
      border-width: 4px;
      &.ascending {
        top: 0;
      }
      &.descending {
        bottom: 0;
      }
    }
  }
  .ascending .sort-caret.ascending {
    border-bottom-color: #ffffff;
  }
  .descending .sort-caret.descending {
    border-top-color: #ffffff !important;
  }
}
::v-deep .el-table__body tr.current-row > td {
  background-color: #cae1f8;
}
::v-deep .el-table--striped .el-table__body tr.el-table__row--striped.current-row td {
  background-color: #cae1f8;
}
::v-deep .el-table--mini th,
::v-deep .el-table--mini td {
  padding: 4px;
  font-size: 12px;
}
::v-deep .el-table--mini td {
  padding: 0 4px;
}
.filter_label {
  color: #000;
  margin-bottom: 10px;
}
::v-deep .iconfont.icon-filter {
  font-size: 12px !important;
  margin-right: 5px !important;
}
.instructions {
  margin-top: 10px;
  padding-bottom: 10px;
  border-top: 1px solid #e6e8ec;
  color: #808385;
  line-height: 20px;
  em {
    display: block;
    padding: 10px 0 5px;
    font-style: normal;
    color: #000;
  }
}
.v-contextmenu {
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.5);
  border: 1px solid #bebebe;
  min-width: 300px;
  ::v-deep .v-contextmenu-item {
    font-size: 12px;
    color: #2f2f2f;
    line-height: 16px;
  }
}
.normal-overdue {
  color: '#E3B424';
}
.normal-overdue-red {
  color: red;
}
.normal-overdue-green {
  color: green;
}
.normal-overdue-green2 {
  color: rgb(10, 170, 60);
}
::v-deep .normal-overdue-red-td td {
  color: red;
}
::v-deep .normal-overdue-red-bold-td td {
  color: red;
  font-weight: bold;
}
::v-deep .normal-overdue-yellow-td td {
  color: yellow;
}
::v-deep .normal-overdue-orange-td td {
  color: orange;
}
::v-deep .normal-overdue-green-td td {
  color: green;
}
::v-deep .normal-overdue-blue-td td {
  color: blue;
}
::v-deep .normal-overdue-set-td td {
  color: #606266;
}
.total-text {
  position: absolute;
  right: 20px;
  bottom: 13px;
  font-size: 14px;
  font-weight: bold;
  display: flex;
  flex-direction: row;
}
::v-deep .el-pagination.is-background {
  .el-pager li {
    height: 20px;
    line-height: 20px;
    min-width: 22px;
  }
  .el-input--mini .el-input__inner {
    height: 20px;
    line-height: 20px;
  }
  .el-input--mini .el-input__icon {
    line-height: 20px;
  }
}
::v-deep .el-pagination button {
  height: 20px;
  line-height: 20px;
  min-width: 18px;
}
::v-deep .el-pagination__editor.el-input .el-input__inner {
  line-height: 20px;
  height: 20px;
}
::v-deep .el-pagination span:not([class*='suffix']),
::v-deep .el-pagination button {
  height: 20px;
  line-height: 20px;
}
.img-size {
  width: 65px;
  height: 65px;
  margin-top: 10px;
  cursor: pointer;
}
.preview-dialog {
  width: 100%;
  height: 100%;
  overflow: hidden;
  ::v-deep .el-dialog {
    height: 100%;
    width: 100%;
    overflow: hidden;
    background: transparent;
  }
  ::v-deep .el-dialog .el-dialog__body {
    margin-top: -60px;
    border-top: none;
    border-bottom: none;
  }
}
.el-carousel__item {
  text-align: center;
}

.hi-upload-file {
  width: 1200px;
  overflow: hidden;
  display: flex;
  align-content: space-between;
  flex-wrap: wrap;
  .img-list {
    flex: 0 0 218px;
    margin-right: 8px;
    width: 218px;
    height: 218px;
    display: flex;
    align-items: center;
    overflow: hidden;
    border: 1px solid #c0ccda;
    .el-image {
      flex: 1;
    }
  }
}
::v-deep .el-carousel__container {
  height: 100%;
}
.el-carousel--horizontal {
  overflow: hidden;
  height: 100%;
  position: fixed;
  left: 0;
  right: 0;
  bottom: 0;
  top: 0;
}
::v-deep .el-carousel__indicators--outside {
  display: none;
}
::v-deep .el-image-viewer__btn {
  position: fixed;
  right: 20px;
  top: 10px;
}
::v-deep .el-image__inner,
.el-image__placeholder,
.el-image__error {
  height: auto;
  vertical-align: middle;
  align-items: center;
}
.img-text {
  display: flex;
  span {
    flex: 0 0 218px;
    margin-right: 8px;
    width: 218px;
    text-align: center;
    line-height: 28px;
  }
}
.el-image-viewer__close {
  color: #fff;
  .el-icon-error:before {
    color: #fff;
  }
}
.link {
  color: #5867dd;
  cursor: pointer;
}
.link:hover {
  text-decoration: underline;
}
::v-deep .el-progress-bar__innertext {
  color: #ffffff !important;
}
::v-deep .el-progress-bar__outer {
  background-color: #ffffff !important;
}
</style>
